
import axios from 'axios';
import { useState } from 'react';

function FileUploadComponent({ userId, onUploadSuccess }) {
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState('');
  const [department, setDepartment] = useState('');
  const departmentOptions = [
    'Customer Service Department',
    'Medical Department',
    'Human Resources Department'
  ];

  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('uploadedBy', userId);
    formData.append('department', department);
    formData.append('description', description);
    try {
      const res = await axios.post('https://clinic123.onrender.com/api/files/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      });
      if (onUploadSuccess) onUploadSuccess(res.data);
      setFile(null);
      setDescription('');
      setDepartment('Elder Care');
      alert('File uploaded successfully!');
    } catch (err) {
      console.error('Upload error:', err);
      alert('File upload failed.');
    }
  };

  return (
    <div className="file-upload-component">
      <div className="upload-form-group">
        <input type="file" onChange={e => setFile(e.target.files[0])} />
      </div>
      <div className="upload-form-group">
        <input type="text" placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
      </div>
      <div className="upload-form-group">
        <select value={department} onChange={e => setDepartment(e.target.value)} required>
          <option value="">Select Department</option>
          {departmentOptions.map(dep => (
            <option key={dep} value={dep}>{dep}</option>
          ))}
        </select>
      </div>
      <button className="upload-button" onClick={handleUpload}>Upload File</button>
    </div>
  );
}

export default FileUploadComponent;
